export default __webpack_public_path__ + "static/media/r.11e295aa.png";